import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { authStorage } from './lib/axios';
import * as React from 'react';
const LoginPage = React.lazy(() => import('./features/auth/LoginPage'));
const AdminRoutes = React.lazy(() => import('./pages/admin/AdminRoutes'));
const ClinicRoutes = React.lazy(() => import('./pages/clinic/ClinicRoutes'));
const DoctorDashboardPage = React.lazy(() => import('./pages/doctor/DoctorDashboardPage'));
const SecretaryDashboardPage = React.lazy(() => import('./pages/secretary/SecretaryDashboardPage'));
const ProfilePage = React.lazy(() => import('./pages/profile/ProfilePage').then(mod => ({ default: mod.ProfilePage })));
const PublicFormPage = React.lazy(() => import('./features/public-form/PublicFormPage'));
const PatientFormPage = React.lazy(() => import('./pages/public/PublicFormPage'));
import { Toaster } from '@/components/ui/toaster';
import Loading from '@/components/Loading';

// Protected Route wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = authStorage.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<Loading />}>
        <Routes>
        {/* Public Routes */}
        <Route path="/forms/:uuid" element={<PublicFormPage />} />
        <Route path="/fill/:submissionId" element={<PatientFormPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Admin grouped route - lazy loaded */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* Admin grouped route - lazy loaded */}
        {/* Individual admin subroutes moved to AdminRoutes to keep admin code separate */}

        {/* Clinic grouped routes - lazy loaded */}
        <Route
          path="/clinic/*"
          element={
            <ProtectedRoute>
              <ClinicRoutes />
            </ProtectedRoute>
          }
        />

        {/* Clinic grouped route is handled by ClinicRoutes */}

        {/* Doctor Routes */}
        <Route
          path="/doctor/dashboard"
          element={
            <ProtectedRoute>
              <DoctorDashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Secretary Routes */}
        <Route
          path="/secretary/dashboard"
          element={
            <ProtectedRoute>
              <SecretaryDashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Profile Route (accessible to all authenticated users) */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />

        {/* Default Redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* 404 Fallback */}
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-4xl font-bold mb-4">404</h1>
              <p className="text-muted-foreground">Página não encontrada</p>
            </div>
          </div>
        } />
        </Routes>
      </React.Suspense>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;

